// Pay the updated total, from the payment the guest just paid on an
// out-of-date page (20261003200010). That payment is refunded in full; the
// booking it named is paid at its current total on the venue's hosted pay
// page (/pay), which prices the cart as it stands, counts the hold down,
// offers to reinstate a hold that ran out, and runs every gate a payment
// runs. The widget never rebuilds the checkout from what it kept before the
// trip to Paystack (those lines are the old ones). The server hands out the
// link from the payment reference alone (superseded_payment_pay_link), so a
// tab that kept nothing (a reload, another device, a cart with add-ons or a
// treatment) can pay too. Nothing here takes money or changes a booking.
import { supabase } from "../config";

export type SupersededPayLink =
  | { ok: true; payUrl: string }
  /** nothing_open: nothing it named is held or lapsed any more (choose a time
   *  again); anything else: try again, or ask the venue. */
  | { ok: false; reason: string };

export async function supersededPayLink(reference: string): Promise<SupersededPayLink> {
  try {
    const { data, error } = await supabase.rpc("superseded_payment_pay_link", { p_reference: reference });
    const url = (data as { pay_url?: unknown } | null)?.pay_url;
    if (!error && (data as { ok?: unknown } | null)?.ok === true && typeof url === "string" && /^https?:\/\//.test(url)) {
      return { ok: true, payUrl: url };
    }
    const reason = (data as { reason?: unknown } | null)?.reason;
    return { ok: false, reason: typeof reason === "string" && reason ? reason : "unavailable" };
  } catch {
    return { ok: false, reason: "unavailable" };
  }
}

/** The refusals that mean the booking is no longer there to pay for. */
export function payLinkMeansNotHeld(reason: string): boolean {
  return reason === "nothing_open" || reason === "booking_confirmed" || reason === "not_superseded";
}
